export default __webpack_public_path__ + "static/media/banner.45184662.webp";